module.exports = __webpack_public_path__ + "img/Centralized data.4e39da1f.svg";